<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs12 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs2 style="padding-left: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs2 style="padding-left: 10px" >
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
              <v-flex xs2 style="padding-left: 10px">
                <v-select
                    :items="teachersBabiPro"
                    value=""
                    name="teachersType"
                    label="Dạng lớp"
                    clearable
                    item-value="value"
                    item-text="text"
                    @clearText="clearToDate"
                    @change="onChangeTeachersBabiPro"
                />
              </v-flex>
             <v-flex xs2 style="padding-left: 10px">
                <v-select
                    :items="packages"
                    value=""
                    name="packageId"
                    item-value="packageId"
                    item-text="packageName"
                    label="Khung ngày của lớp"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangePackage"
                />
              </v-flex>
              <v-flex xs2 style="padding-left: 10px">
                <v-select
                    :items="programs"
                    name="programTimeId"
                    item-value="programTimeId"
                    item-text="programTimeName"
                    label="Giờ"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeProgramTime"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 style="padding: 10px">
            <v-layout wrap>

            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="1000"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/kidClassBabiPro/countCreateClass?sortField=status,id&"
            create-url=""
            delete-url=""
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="false"
            :accept-create="false"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  props: {
    programs: {
      type: Array,
      default: [],
    },
    packages: {
      type: Array,
      default: [],
    },
  },

  data: () => {
    return {
      teachersBabiPro: cateContants.teachersBabiPro,
      formName: "Đếm số lớp có thể tạo theo ngày",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      fromDate: null,
      toDate: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
        teachersType: null,
        programTime: null,
        programTimeId: null,
        packageId:null

      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'learDateStr',
          text: 'Ngày_học',
          sortable: false,
          width: "10%",
          search: false,
          headerStyle: "text-align:center;",
        },
        /*{
          value: 'teachersTypeName',
          text: 'Dạng_lớp',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center;",
        },
        {
          value: '',
          text: 'Khung_ngày_của_lớp',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center; ",
        },
        {
          value: 'numberDate',
          text: 'Giờ',
          sortable: false,
          width: "10%",
          search: false,
          headerStyle: "text-align:center;",
        },*/
        {
          value: 'numberCreateClass',
          text: 'Số_lớp_có_thể_tạo ',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center;",
        },
      ],
    };
  },

  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.programs = data;
              }
            }
        );

    // kidPackage
    axios.post(
        process.env.VUE_APP_API_URL + "/kidPackage/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.packages = data;
              }
            }
        );

  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    onChangeTeachersBabiPro(teachersType) {
      this.hiddenFields.teachersType = teachersType;
    },
    onChangeProgramTime(programTimeId) {
      this.hiddenFields.programTimeId = programTimeId;
    },
    onChangePackage(packageId) {
      this.hiddenFields.packageId = packageId;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
